import React, { useState } from 'react';
import { Platform, Pressable, View } from 'react-native';
import { Link } from 'expo-router';
import Icon from '@/components/Icon';
import Text from '@/components/Typography/Text';
import { useLanding } from './LandingKit';
import { USE_CASE_CAPABILITIES } from '../../../shared/public/use-case-capabilities.cjs';

export default function UseCaseToolkit({ items }) {
  const { c } = useLanding();
  const [selected, setSelected] = useState(items[0]?.key);
  const item = items.find(value => value.key === selected) || items[0];
  if (!item) return null;
  const feature = USE_CASE_CAPABILITIES[item.key];
  return <View style={{ marginTop: 28, gap: 20 }}>
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 10 }}>
      {items.map(value => { const current = USE_CASE_CAPABILITIES[value.key]; const active = item.key === value.key; return <Pressable key={value.key}
        accessibilityRole="button" accessibilityLabel={`Explore ${current.label}`} onPress={() => setSelected(value.key)}
        {...(Platform.OS === 'web' ? { 'aria-pressed': active } : { accessibilityState: { selected: active } })}
        style={{ minHeight: 48, flexDirection: 'row', alignItems: 'center', gap: 9, paddingVertical: 12, paddingHorizontal: 16, borderWidth: 1, borderRadius: 10, borderColor: active ? c.ink : c.ruleStrong, backgroundColor: active ? c.ink : c.page }}>
        <Icon name={current.icon} size={17} color={active ? c.page : c.ink} /><Text weight="medium" style={{ color: active ? c.page : c.ink, fontSize: 14 }}>{current.label}</Text>
      </Pressable>; })}
    </View>
    <View accessibilityLiveRegion="polite" style={{ padding: 26, borderRadius: 18, backgroundColor: c.panel, gap: 14, maxWidth: 800 }}>
      <Text tag="h3" weight="semibold" style={{ color: c.ink, fontSize: 24, lineHeight: 32 }}>{feature.label}</Text>
      <Text tag="p" style={{ color: c.muted, fontSize: 16, lineHeight: 26 }}>{item.description}</Text>
      {!!feature.requirement && <Text style={{ color: c.muted, fontSize: 13, lineHeight: 22 }}>{feature.requirement}</Text>}
      <Link href={feature.href} style={{ color: c.ink, fontSize: 14, lineHeight: 24, paddingVertical: 10, textDecorationLine: 'underline' }}>How {feature.label} works</Link>
    </View>
  </View>;
}
